// extracted by mini-css-extract-plugin
module.exports = {"breakpoints":"'styles/breakpoints.module.css'","MOBILE_WIDTH_MAX":"992px","section":"styles_section__Cmdb7","overlay":"styles_overlay__B7m_D","main":"styles_main__uELK3"};